export default __webpack_public_path__ + "static/media/logo-contact.84b48cec.svg";